import PT from 'prop-types';
import styles from './panel.module.less';

const Panel = ({ children, className, active, shouldHaveBackground }) => {
    const activeClass = active ? styles.panelActive : '';
    const backgroundClass = shouldHaveBackground ? styles.withBackground : '';
    return <section className={`${styles.panel} ${className} ${activeClass} ${backgroundClass}`}>{children}</section>;
};

Panel.defaultProps = {
    className: '',
    active: false,
    shouldHaveBackground: false,
};

Panel.propTypes = {
    className: PT.string,
    active: PT.bool,
    shouldHaveBackground: PT.bool,
    children: PT.node.isRequired,
};

export default Panel;
